import { SxProps, Theme } from "@mui/material";
import theme from "../../../../theme";

export const menuSx:SxProps<Theme> = {
  position: "absolute",
  top: theme.spacing(16/8),
  right: theme.spacing(16/8)
}